var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Ширина")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.fields.inputWidth,
                  "error-messages": _vm.errorMessages.width,
                },
                on: {
                  input: function ($event) {
                    return _vm.ChangingHandler($event, "Width", "input")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Ед. измерения")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-value": "value",
                  "item-text": "title",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.fields.valueWidth,
                  items: _vm.$options.valueTypesCSSList,
                },
                on: {
                  change: function ($event) {
                    return _vm.ChangingHandler($event, "Width", "value")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Высота")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.fields.inputHeight,
                  "error-messages": _vm.errorMessages.height,
                },
                on: {
                  input: function ($event) {
                    return _vm.ChangingHandler($event, "Height", "input")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Ед. измерения")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-value": "value",
                  "item-text": "title",
                  "hide-details": "",
                  dense: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.fields.valueHeight,
                  items: _vm.$options.valueTypesCSSList,
                },
                on: {
                  change: function ($event) {
                    return _vm.ChangingHandler($event, "Height", "value")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-row", { attrs: { "no-gutters": "" } }, [_c("v-divider")], 1),
      _c(
        "v-row",
        { staticClass: "mt-5 mb-10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            [
              _c("span", [
                _vm._v(
                  "Список: (" + _vm._s(_vm.listItem.data.slides.length) + ")"
                ),
              ]),
              _c("ErrorMessage", {
                attrs: { message: _vm.errorMessages.slides },
              }),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: {
                small: "",
                disabled: _vm.isLoading,
                loading: _vm.isLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.mixAddListItemItemHandler(
                    "slides",
                    _vm.$options.widgetItems
                  )
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v(" mdi-plus ")])],
            1
          ),
        ],
        1
      ),
      _vm._l(
        _vm.listItem.data.slides,
        function (listItemItem, listItemItemIndex) {
          return _c(
            "v-row",
            {
              key: listItemItemIndex,
              staticClass: "mb-5",
              attrs: { align: "center" },
            },
            [
              _c(
                "v-card",
                {
                  attrs: {
                    "max-width": "100%",
                    flat: "",
                    color: "transparent",
                  },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-row",
                        {
                          attrs: { align: "center", justify: "space-between" },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              " Слайд " + _vm._s(listItemItemIndex + 1) + ": "
                            ),
                          ]),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                small: "",
                                disabled: _vm.isLoading,
                                loading: _vm.isLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.mixRemoveListItemItemHandler(
                                    listItemItemIndex,
                                    "slides"
                                  )
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { color: "red" } }, [
                                _vm._v("mdi-trash-can-outline"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: { "no-gutters": "", align: "center" },
                                },
                                [
                                  _c("MediaFilePicker", {
                                    attrs: {
                                      multiple: false,
                                      label: "Медиа файл",
                                      isShowCaption: true,
                                      caption: listItemItem.data.caption,
                                      "file-type":
                                        _vm.$options.mediaTypesByKeys.IMAGE,
                                      value: listItemItem.data.image,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.mixUploadImageHandler(
                                          $event,
                                          "slides",
                                          "image",
                                          listItemItemIndex
                                        )
                                      },
                                      "change-caption": function ($event) {
                                        return _vm.mixChangeListItemItemHandler(
                                          $event,
                                          "slides",
                                          listItemItemIndex,
                                          "caption"
                                        )
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "preview-bottom",
                                          fn: function () {
                                            return [
                                              _c("ErrorMessage", {
                                                attrs: {
                                                  message: _vm.errorMessages[
                                                    listItemItemIndex
                                                  ]
                                                    ? _vm.errorMessages[
                                                        listItemItemIndex
                                                      ].image
                                                    : "",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("span", [_vm._v("Заполнение изображения")]),
                              _c("v-select", {
                                attrs: {
                                  outlined: "",
                                  "item-value": "value",
                                  "item-text": "title",
                                  "return-object": "",
                                  "hide-details": "",
                                  dense: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.fit,
                                  items: _vm.$options.imageFits,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "slides",
                                      listItemItemIndex,
                                      "fit"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-row", [_c("v-divider")], 1),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "span",
                                [
                                  _vm._v("Заголовок ("),
                                  _c("TranslationIcon"),
                                  _vm._v(")"),
                                ],
                                1
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.title,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "slides",
                                      listItemItemIndex,
                                      "title"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c("QuillEditorVue", {
                            attrs: {
                              cols: 12,
                              content: listItemItem.data.description,
                              loading: _vm.isLoading,
                              disabled: _vm.isLoading,
                              "light-mode": "",
                            },
                            on: {
                              input: function ($event) {
                                return _vm.mixChangeListItemItemHandler(
                                  $event,
                                  "slides",
                                  listItemItemIndex,
                                  "description"
                                )
                              },
                              onChangeContent: function ($event) {
                                return _vm.mixChangeListItemHandler(
                                  $event,
                                  "descriptionForMobile"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-row", [_c("v-divider")], 1),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "span",
                                [
                                  _vm._v("Заголовок кнопки ("),
                                  _c("TranslationIcon"),
                                  _vm._v(")"),
                                ],
                                1
                              ),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.buttonTitle,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "slides",
                                      listItemItemIndex,
                                      "buttonTitle"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("span", [_vm._v("Ссылка кнопки")]),
                              _c("v-text-field", {
                                attrs: {
                                  outlined: "",
                                  disabled: _vm.isLoading,
                                  loading: _vm.isLoading,
                                  value: listItemItem.data.buttonLink,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.mixChangeListItemItemHandler(
                                      $event,
                                      "slides",
                                      listItemItemIndex,
                                      "buttonLink"
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }